import { createFileRoute } from '@tanstack/react-router';
import { WarehouseConfigRouteView } from '@/pages/workspaces/integrations/warehouse/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The connected-sync config view, keyed by storage provider (`s3`, `gcs`, `azure_blob`, `yandex`).
 * The three connector landing pages are static siblings, so they win this segment.
 *
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this page.
 */
function WarehouseConfigRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <WarehouseConfigRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type')({
  component: WarehouseConfigRoute,
});
